import styled from 'styled-components';

import themeColors from '@polyai/ui/styles/config/colors';
import sizes from '@polyai/ui/styles/config/sizes';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

export const Wrapper = styled.div`
    position: fixed;
    z-index: 25;

    display: flex;
    gap: ${themeSpacing.xs3};
    align-items: center;
    justify-content: space-between;

    width: 100%;
    height: ${sizes.bannerHeight}px;
    padding: 0 ${themeSpacing.sm3};

    background: ${themeColors.backgroundInverse};
    border-bottom: 1px solid ${themeColors.borderSubtleInverse};
`;

export const BannerGroup = styled.div`
    display: flex;
    gap: ${themeSpacing.xs3};
    align-items: center;
`;

export const Text = styled.p`
    font-size: ${text.size.body.regular};
    line-height: ${themeSpacing.sm1};
    color: ${themeColors.textPrimaryInverse};
    word-wrap: break-word;
`;

export const Spacer = styled.div`
    margin-left: auto; 
`;
